import { PageHeaderContainerProps } from './type'

export const PageHeaderContainer = (props: PageHeaderContainerProps) => {
  return <div className="mb-5">{props.children}</div>
}
